export default __webpack_public_path__ + "img/bENtNeeM.6687fc5d.svg";